import React, { Component } from "react";
import { Container, Col, Tabs, Tab, Accordion, Row, Image, Alert } from "react-bootstrap";
import * as utils from "../../utils.js";

import DesplegableGrupoTrabajo from "./desplegables/desplegable_grupo_trabajo";
import Cargos from "../cargos/Cargos.jsx";
export default class GrupoTrabajoDetalle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Datos que serán asignados en los get
      DatosGrupoTrabajo: "",
      Finalidad: "",
      // Array que contiene si se muestran o no los modales
      showModalArray: [],
    };

    this.handleButtonShow = this.handleButtonShow.bind(this);
    this.nullField = this.nullField.bind(this);
    this.setInformacionOrganismo = this.setInformacionOrganismo.bind(this);
    this.setFinalidad = this.setFinalidad.bind(this);
  }

  async componentDidMount() {
    let cstate = this.state;
    let id_provincia = this.props.computedMatch.path === "/direccionGeneral/gruposTrabajo/:id_t" ? "14" : this.props.computedMatch.params.id_p;

    cstate.DatosGrupoTrabajo = await utils.callAjaxGet(
      "GET",
      process.env.REACT_APP_API_URL + "/provincias/" + id_provincia + "/gruposTrabajo/" + this.props.computedMatch.params.id_t,
      this.props.ErrorHandling
    );

    cstate.Finalidad = await utils.callAjaxGet(
      "GET",
      process.env.REACT_APP_API_URL + "/provincias/" + id_provincia + "/gruposTrabajo/" + this.props.computedMatch.params.id_t + "/propositos",
      this.props.ErrorHandling
    );

    // Inicializamos la array modal que sirve para controlar los modales que se muestran
    cstate.showModalArray.push(false); // [0] controla modal informacion del organismo

    this.setState(cstate);
  }

  // Método Set, se encargan de actualizar el estado de este componente cuando se edita en los hijos
  setInformacionOrganismo(response) {
    this.setState({ DatosGrupoTrabajo: response });
  }

  async setFinalidad() {
    let id_provincia = this.props.computedMatch.path === "/direccionGeneral/gruposTrabajo/:id_t" ? "14" : this.props.computedMatch.params.id_p;

    let Finalidad = await utils.callAjaxGet(
      "GET",
      process.env.REACT_APP_API_URL + "/provincias/" + id_provincia + "/gruposTrabajo/" + this.props.computedMatch.params.id_t + "/propositos",
      this.props.ErrorHandling
    );
    this.setState({ Finalidad: Finalidad });
  }

  // Funcion que se encarga de controlar el array de los modales
  handleButtonShow(event) {
    // Creamos una matriz auxiliar
    let showModalArrayAux = this.state.showModalArray;

    // Recibimios un id que se corresponde con la posicion del array
    // en la que se encuentra el showModal.

    if (event) {
      showModalArrayAux[event.target.id] = !this.state.showModalArray[event.target.id];
    }

    //Si el evento es nulo o es cerrar ponemos todo a false
    if (event === undefined || event.target.name === "Cerrar") {
      for (let i = 0; i < showModalArrayAux.length; i++) {
        showModalArrayAux[i] = false;
      }
    }
    this.setState({
      showModalArray: showModalArrayAux,
    });
  }

  // Función que cambia una variable del estado a null tambn se hace a dos niveles, en caso de foto la pone por defecto
  nullField(field, secondOrder) {
    let cstate = this.state;
    if (secondOrder === "photo") {
      cstate.DatosGrupoTrabajo.photo = "/images/logoSTJ.png";
    } else if (secondOrder !== null) {
      cstate.DatosGrupoTrabajo[secondOrder][field] = null;
    } else {
      cstate.DatosGrupoTrabajo[field] = null;
    }
    this.setState(cstate);
  }

  onError(e) {
    let cstate = this.state;
    // Si hay un error cargamos la foto del logo
    e.target.onerror = null;
    e.target.src = "/images/logoSTJ.png";
    cstate.DatosGrupoTrabajo.photo = "/images/logoSTJ.png";

    this.setState(cstate);
  }

  render() {
    let id_provincia = this.props.computedMatch.path === "/direccionGeneral/gruposTrabajo/:id_t" ? "14" : this.props.computedMatch.params.id_p;

    let datosGrupoTrabajo = this.state.DatosGrupoTrabajo ? (
      <Container className="mt-3">
        <Row bg="light" className="shadow-lg mx-3 my-5 align-items-center">
          <Col className="d-flex justify-content-center" xs={12} sm={12} lg={6}>
            <Image
              className="img-fluid-detalle"
              variant="top"
              src={
                this.state.DatosGrupoTrabajo.photo
                  ? process.env.REACT_APP_API_URL + "/download/provincias/" + id_provincia + "/gruposTrabajo/" + this.state.DatosGrupoTrabajo.id + "?aux=" + this.state.DatosGrupoTrabajo.photo
                  : `/images/provincias/${id_provincia}.png`
              }
              onError={(e) => this.onError(e)}
              alt="grupoImg"
            />
          </Col>
          <Col xs={12} sm={12} lg={6}>
            <h5 className="detail-title-sister">{this.state.DatosGrupoTrabajo.name}</h5>
          </Col>
        </Row>
        <Row>
          <Col>
            <Tabs>
              <Tab eventKey="equipo" title="Información del Equipo">
                <Accordion defaultActiveKey={'"' + 0 + '"'}>
                  <DesplegableGrupoTrabajo
                    state={this.state}
                    handleButtonShow={this.handleButtonShow}
                    setInformacionOrganismo={this.setInformacionOrganismo}
                    id_provincia={id_provincia}
                    setFinalidad={this.setFinalidad}
                    setAlert={this.props.setAlert}
                    ErrorHandling={this.props.ErrorHandling}
                    nullField={this.nullField}
                  ></DesplegableGrupoTrabajo>
                </Accordion>
              </Tab>
              <Tab eventKey="cargosTrabajo" title="Lista de Miembros">
                <Cargos
                  type="equiposComisiones"
                  idEntidad={this.props.computedMatch.path === "/direccionGeneral/gruposTrabajo/:id_t" ? "14" : this.props.computedMatch.params.id_p}
                  idSubEntidad={this.props.computedMatch.params.id_t}
                />
              </Tab>
            </Tabs>
          </Col>
        </Row>
      </Container>
    ) : null;
    return <React.Fragment>{datosGrupoTrabajo}</React.Fragment>;
  }
}
